import { defTrieMap, type TrieMap } from "@-/com.npmjs.thi-ng-trie";

export class ChineseWordsTrie {
  readonly #trie: TrieMap<true>;

  constructor(words: Iterable<string>) {
    this.#trie = defTrieMap(
      (function* () {
        for (const word of words) {
          yield [word, true] as const;
        }
      })(),
    );
  }

  has(word: string): boolean {
    return this.#trie.has(word);
  }

  /**
   * Longest dictionary word starting at `index` in `text`, or undefined.
   * Cost is O(length of the match), not vocabulary size.
   */
  longestWordAt(text: string, index: number): string | undefined {
    return this.#trie.knownPrefix(text.slice(index));
  }
}

/** The set of known database words, as a prefix trie for longest-match segmentation. */
export type KnownDatabaseWords = ChineseWordsTrie;
